import Socket from 'services/Socket';
import catchUpInbox, {
  consumeSocketConnect,
  focusCatchUpDecision,
} from 'store/app/ui/focus/catchUpInbox';

export const SET_FOCUS = 'SET_FOCUS';
export const SET_ACTIVE = 'SET_ACTIVE';

const setFocus = focus => (dispatch, getState) => {
  const hadFocus = getState().elements.Focus.hasFocus;
  Socket.emit('blurred', { blurred: !focus });
  dispatch({
    type: SET_FOCUS,
    focus,
  });
  const decision = focusCatchUpDecision({
    focus,
    hadFocus,
    socketConnected: Socket.isConnected(),
  });
  if (decision === 'connect') {
    Socket.connect();
    return;
  }
  if (decision === 'catchUp') {
    dispatch(catchUpInbox());
  }
};

const setActive = active => dispatch => {
  Socket.emit('active', !!active);
  dispatch({
    type: SET_ACTIVE,
    active,
  });
};

const onConnect = () => (dispatch, getState) => {
  const { isActive, hasFocus } = getState().elements.Focus;
  Socket.emit('blurred', { blurred: !hasFocus });
  Socket.emit('active', !!isActive);
  if (consumeSocketConnect()) {
    dispatch(catchUpInbox());
  }
};

export default { onConnect, setActive, setFocus };
